<template>
  <div>
    <v-textarea
      style="font-size: 11px !important;"
      :error-messages="errorMessages"
      :required="required"
      :value="content"
      auto-grow
      hide-details
      :rows="rows"
      :label="label"
      placeholder=" "
      :maxlength="maxlength"
      @input="updateSelf"
      outlined
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "SimpleTextInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: String,
    label: String,
    errorMessages: Object,
    maxlength: {
      type: Number,
      default: 450
    },
    rows: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      menu: false,
      required: false
    };
  },
  methods: {
    updateSelf(content) {
      this.$emit("input", content);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.v-textarea.v-text-field--box.v-text-field--outlined .v-label,
.v-textarea.v-text-field--box.v-text-field--single-line .v-label,
.v-textarea.v-text-field--enclosed.v-text-field--outlined .v-label,
.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
  top: 10px !important;
}
</style>
